import { useQuery } from '@tanstack/react-query';
import { getMeMastery } from '../services/mastery.service';

// The referee's per-rule mastery for the Home radar + drill list. Gated by `enabled` exactly like
// useRefereeStatsQuery — only clip-answering roles have mastery; a super_admin would 403. 30s stale
// window keeps it instant on revisit and quietly fresh after new answers.
export function useMasteryQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['referee-mastery'],
    queryFn: getMeMastery,
    enabled,
    staleTime: 30_000,
  });
}
